/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';

export const ListingStatusSchema = z.enum(["DRAFT", "PENDING", "APPROVED", "ACTIVE", "PAUSED", "STOPPED", "CLOSED", "HIDDEN", "ARCHIVED", "DELETED"])
